import { useCallback, useEffect, useMemo, useState } from "react";
import Tabela from "../../../Componentes/Utils/Tabela"
import GenericHeader from "../../../Componentes/GenericHeader";
import Filters from "../../../Componentes/Utils/Filters";
import Stats from "../../../Componentes/Utils/Stats";
import axios from "axios";
import { formatarData } from "../../../Funcoes/FormatarData";
import styled, { keyframes } from "styled-components";
import FilterContainer from "../../../Componentes/Utils/FilterContainer";
import { VscFilePdf } from "react-icons/vsc";
import { LuLoaderCircle } from "react-icons/lu";
import { saveAs } from "file-saver";


const IconeContainer = styled.div`
    width: 40px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
`
const spin = keyframes`
    from{ transform: rotate( 0deg ) }
    to{ transform: rotate( 360deg ) }
`
const IconePDF = styled(VscFilePdf)`
    margin: auto;
    cursor: pointer;
`
const IconeLoad = styled(LuLoaderCircle)`
    margin: auto;
    animation: ${spin} 1s linear infinite;
`
const TableCells = styled.td`
    text-align: ${(props) => {
        if (props.align === "left") return "left !important";
        if (props.align === "center") return "center !important";
        if (props.align === "right") return "right !important";
        return "left !important";
    }};
`
const ContainerStats = styled.div`
    margin: auto;
    width: 100%;
    display: flex;
    flex-direction: column;
`
const TituloStats = styled.h3`
    margin: 8px auto;
    font-weight: bold;
`
const ContainerStatsDiv = styled.div`
    width: 100%;
    display: flex;
`
const ContainerStatsText = styled.div`
    width: calc( 50% - 10px );
    margin: 0 auto;
    text-align: center;
    & p{
        margin: 5px 0;
    }
`

const TabelaNcs = () => {

    const [loading, setLoading] = useState(true);

    const [ncList, setNcList] = useState([]);
    const [ncListFilter, setNcListFilter] = useState([]);

    const fetchNcs = async () => {

        setLoading(true);

        try {

            const { data } = await axios.get('https://sistemaintegrado.palmont.com.br/Painel/API/Checklist/GetNCList/', {
                withCredentials: true
            });
            setNcList(data)
            setNcListFilter(data)

            console.log(data);

        } catch (e) {

            console.error(e);

        } finally {

            setLoading(false);

        }

    }

    useEffect(() => {
        fetchNcs();
    }, [])

    const listaCentroCusto = useMemo(() => [...new Set(ncList.map((obj) => obj.centro_custo))].sort(), [ncList]);
    const listaContrato = useMemo(() => [...new Set(ncList.map((obj) => obj.contrato))].sort(), [ncList]);
    const listaUsuario = useMemo(() => [...new Set(ncList.map((obj) => obj.usuario))].sort(), [ncList]);
    const listaAuditado = useMemo(() => [...new Set(ncList.map((obj) => obj.nome_audit))].sort(), [ncList]);
    const listaLider = useMemo(() => [...new Set(ncList.map((obj) => obj.lider_nome))].sort(), [ncList]);
    const listaEquipe = useMemo(() => [...new Set(ncList.map((obj) => obj.equipe))].sort(), [ncList]);
    const listaTipo = useMemo(() => [...new Set(ncList.map((obj) => obj.tipo))].sort(), [ncList]);
    const listaModelo = useMemo(() => [...new Set(ncList.map((obj) => obj.modelo))].sort(), [ncList]);

    const [centroCustoFilter, setCentroCustoFilter] = useState([]);
    const [contratoFilter, setContratoFilter] = useState([]);
    const [usuarioFilter, setUsuarioFilter] = useState([]);
    const [auditadoFilter, setAuditadoFilter] = useState([]);
    const [liderFilter, setLiderFilter] = useState([]);
    const [equipeFilter, setEquipeFilter] = useState([]);
    const [tipoFilter, setTipoFilter] = useState([]);
    const [modeloFilter, setModeloFilter] = useState([]);
    const [statusFilter, setStatusFilter] = useState([]);
    const [situacaoFilter, setSituacaoFilter] = useState([]);

    const handleFilter = useCallback(() => {
        setNcListFilter(
            ncList.filter((item) => {
                const obra = !centroCustoFilter.length || centroCustoFilter.some(obj => (item.centro_custo || '').includes(obj.value));
                const contrato = !contratoFilter.length || contratoFilter.some(obj => (item.contrato || '').includes(obj.value));
                const usuario = !usuarioFilter.length || usuarioFilter.some(obj => (item.usuario || '').includes(obj.value));
                const auditado = !auditadoFilter.length || auditadoFilter.some(obj => (item.nome_audit || '').includes(obj.value));
                const lider = !liderFilter.length || liderFilter.some(obj => (item.lider_nome || '').includes(obj.value));
                const equipe = !equipeFilter.length || equipeFilter.some(obj => (item.equipe || '').includes(obj.value));
                const tipo = !tipoFilter.length || tipoFilter.some(obj => (item.tipo || '').includes(obj.value));
                const modelo = !modeloFilter.length || modeloFilter.some(obj => (item.modelo || '').includes(obj.value));
                const status = !statusFilter.length || statusFilter.some(obj => (item.status || '').includes(obj.value));
                const situacao = !situacaoFilter.length || situacaoFilter.some(obj => (item.situacao || '').includes(obj.value));

                return obra && contrato && usuario && auditado && lider && equipe && tipo && modelo && status && situacao;
            })
        )
    }, [ncList, centroCustoFilter, contratoFilter, usuarioFilter, auditadoFilter, liderFilter, equipeFilter, tipoFilter, modeloFilter, statusFilter, situacaoFilter]);

    useEffect(() => {
        handleFilter()
    }, [handleFilter])

    const somaEmAberto = ncListFilter.filter((obj) => obj.status === 'EM ANDAMENTO').length || 0;
    const somaFinalizado = ncListFilter.filter((obj) => obj.status === 'FINALIZADA').length || 0;
    const somaNoPrazo = ncListFilter.filter((obj) => obj.situacao === 'NO PRAZO').length || 0;
    const somaAtrasado = ncListFilter.filter((obj) => obj.situacao === 'ATRASADA').length || 0;

    const [loadingIds, setLoadingIds] = useState([]);

    const handleClick = async (id) => {
        setLoadingIds((prev) => [...prev, id]);

        try {

            const { data } = await axios.post('https://sistemaintegrado.palmont.com.br/Painel/API/Checklist/GeneratePdfNC/',
                { id: id },
                { responseType: "blob" }
            )

            const pdfBlob = new Blob([data], { type: "application/pdf" });
            saveAs(pdfBlob, `nao-conformidade-${id}.pdf`);

        } catch (e) {

            console.error(e);

        } finally {

            setLoadingIds((prev) => prev.filter((loadingId) => loadingId !== id));

        }

    }

    return (
        <>
            <GenericHeader>
                <Filters columns={5} >
                    <FilterContainer
                        type="select"
                        options={listaCentroCusto}
                        optType={'obj'}
                        placeholder="CENTRO DE CUSTO..."
                        valor={centroCustoFilter}
                        changeFunc={(value) => setCentroCustoFilter(value)}
                    />
                    <FilterContainer
                        type="select"
                        options={listaContrato}
                        optType={'obj'}
                        placeholder="CONTRATO..."
                        valor={contratoFilter}
                        changeFunc={(value) => setContratoFilter(value)}
                    />
                    <FilterContainer
                        type="select"
                        options={listaUsuario}
                        optType={'obj'}
                        placeholder="USUARIO..."
                        valor={usuarioFilter}
                        changeFunc={(value) => setUsuarioFilter(value)}
                    />
                    <FilterContainer
                        type="select"
                        options={listaAuditado}
                        optType={'obj'}
                        placeholder="AUDITADO..."
                        valor={auditadoFilter}
                        changeFunc={(value) => setAuditadoFilter(value)}
                    />
                    <FilterContainer
                        type="select"
                        options={listaLider}
                        optType={'obj'}
                        placeholder="LIDER..."
                        valor={liderFilter}
                        changeFunc={(value) => setLiderFilter(value)}
                    />
                    <FilterContainer
                        type="select"
                        options={listaEquipe}
                        optType={'obj'}
                        placeholder="EQUIPE..."
                        valor={equipeFilter}
                        changeFunc={(value) => setEquipeFilter(value)}
                    />
                    <FilterContainer
                        type="select"
                        options={listaTipo}
                        optType={'obj'}
                        placeholder="TIPO..."
                        valor={tipoFilter}
                        changeFunc={(value) => setTipoFilter(value)}
                    />
                    <FilterContainer
                        type="select"
                        options={listaModelo}
                        optType={'obj'}
                        placeholder="MODELO..."
                        valor={modeloFilter}
                        changeFunc={(value) => setModeloFilter(value)}
                    />
                    <FilterContainer
                        type="select"
                        options={[
                            "EM ANDAMENTO",
                            "FINALIZADA"
                        ]}
                        optType={'obj'}
                        placeholder="STATUS..."
                        valor={statusFilter}
                        changeFunc={(value) => setStatusFilter(value)}
                    />
                    <FilterContainer
                        type="select"
                        options={[
                            "ATRASADA",
                            "NO PRAZO"
                        ]}
                        optType={'obj'}
                        placeholder="SITUAÇÃO..."
                        valor={situacaoFilter}
                        changeFunc={(value) => setSituacaoFilter(value)}
                    />
                </Filters>
                <Stats>
                    <ContainerStats>
                        <TituloStats>TOTAL DE NC'S: {ncListFilter.length}</TituloStats>
                        <ContainerStatsDiv>
                            <ContainerStatsText>
                                <p>EM ANDAMENTO: {somaEmAberto}</p>
                                <p>FINALIZADO: {somaFinalizado}</p>
                            </ContainerStatsText>
                            <ContainerStatsText>
                                <p>NO PRAZO: {somaNoPrazo}</p>
                                <p>ATRASADO: {somaAtrasado}</p>
                            </ContainerStatsText>
                        </ContainerStatsDiv>
                    </ContainerStats>
                </Stats>
            </GenericHeader>
            <Tabela loading={loading} >
                <thead>
                    <tr>
                        <th>CHECKLIST</th>
                        <th>TIPO</th>
                        <th>MODELO</th>
                        <th>CENTRO CUSTO</th>
                        <th>CONTRATO</th>
                        <th>AREA</th>
                        <th>USUARIO</th>
                        <th>AUDITADO</th>
                        <th>LIDER</th>
                        <th>EQUIPE</th>
                        <th>ITEM</th>
                        <th>STATUS</th>
                        <th>PRAZO</th>
                        <th>ENCERRAMENTO</th>
                        <th>SITUAÇÃO</th>
                        <th />
                    </tr>
                </thead>
                <tbody>{ncListFilter.map((obj) => (
                    <tr key={obj.id} >
                        <TableCells align="center" >{obj.id_checklist}</TableCells>
                        <TableCells>{obj.tipo}</TableCells>
                        <TableCells>{obj.modelo ? obj.modelo : '-'}</TableCells>
                        <TableCells>{obj.centro_custo}</TableCells>
                        <TableCells>{obj.contrato}</TableCells>
                        <TableCells>{obj.area}</TableCells>
                        <TableCells>{obj.usuario}</TableCells>
                        <TableCells>{obj.nome_audit}</TableCells>
                        <TableCells>{obj.lider_nome}</TableCells>
                        <TableCells>{obj.equipe}</TableCells>
                        <TableCells>{obj.item}</TableCells>
                        <TableCells>{obj.status}</TableCells>
                        <TableCells align="center" >{formatarData(obj.data_prazo)}</TableCells>
                        <TableCells align="center" >{obj.data_realizada ? formatarData(obj.data_realizada) : '-'}</TableCells>
                        <TableCells>{obj.situacao}</TableCells>
                        <TableCells align="center" >
                            <IconeContainer>
                                {loadingIds.includes(obj.id)
                                    ? <IconeLoad size={25} />
                                    : <IconePDF size={25} onClick={(e) => {
                                        e.stopPropagation();
                                        handleClick(obj.id);
                                    }} />
                                }
                            </IconeContainer>
                        </TableCells>
                    </tr>
                ))}
                </tbody>
            </Tabela>
        </>
    )
}

export default TabelaNcs;